__webpack_require__.p = "/v2/camp/";